import { render, staticRenderFns } from "./Classmate.vue?vue&type=template&id=990162bc&scoped=true&"
import script from "./Classmate.vue?vue&type=script&lang=js&"
export * from "./Classmate.vue?vue&type=script&lang=js&"
import style0 from "./Classmate.vue?vue&type=style&index=0&id=990162bc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990162bc",
  null
  
)

export default component.exports